import { config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false; // disable automatic CSS injection by FontAwesome, as we handle it manually in the main.css file
